import axios from 'axios'
import * as endpoints from './const'
import { CSVExport } from '../utils/exports'

class ReportsApi {
  static getReports(fetchParams) {
    console.log('getReports', fetchParams)
    return axios
      .get(`${endpoints.REPORTS}`, {
        params: fetchParams,
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }

  static getReportFields(id, category) {
    return axios
      .get(`${endpoints.REPORTS}/${id}?category=${category}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }

  static exportReport(
    {
      id,
      category,
      companyCode,
      countryCode,
      title,
      businessReportId,
      legacyReportConfiguration,
      restrictions,
    },
    getExportCallback
  ) {
    return axios
      .post(
        endpoints.REPORTS_EXPORT,
        {
          id,
          category,
          companyCode,
          countryCode,
          businessReportId,
          legacyReportConfiguration,
          restrictions,
        },
        { responseType: 'arraybuffer' }
      )
      .then(response => {
        if (getExportCallback) getExportCallback()
        return { data: response.data, headers: response.headers }
      })
      .then(
        data => {
           return CSVExport(
            data.data,
            category === 'legacy'
              ? id === 'C426DFFA-A581-410C-8DE3-F6AE57A16FA2'
                ? `${category}-report-${title}.pdf`
                : `${category}-report-${title}.xls`
              : data.headers['content-type'].indexOf(
                  'application/vnd.ms-excel'
                ) !== -1
                ? `${category}-report-${title}.xlsx`
                : `${category}-report-${title}.csv`
          )
        }

        // {
        //   const file = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        //   const fileURL = URL.createObjectURL(file);
        //   let tempLink = document.createElement('a');
        //   tempLink.href = fileURL;
        //   tempLink.setAttribute('download', `${category}-report-${title}.csv`);
        //   tempLink.click();
        // }
      )
      .catch(error => {
        throw error
      })
  }

  static customisedExportReport(params) {
    const { category, title } = params
    return axios
      .post(endpoints.REPORTS_EXPORT, params, { responseType: 'arraybuffer' })
      .then(response => response.data)
      .then(
        data => CSVExport(data, `${category}-report-${title}.csv`)
        // {
        //   const file = new Blob([data], {type: 'text/csv;charset=utf-8;'});
        //   const fileURL = URL.createObjectURL(file);
        //   let tempLink = document.createElement('a');
        //   tempLink.href = fileURL;
        //   tempLink.setAttribute('download', `${category}-report-${title}.csv`);
        //   tempLink.click();
        // }
      )
      .catch(error => {
        throw error
      })
  }

  static createReport(params) {
    return axios
      .post(endpoints.REPORTS, params)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }

  static updateReport(params) {
    return axios
      .put(endpoints.REPORTS, params)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }

  static deleteReport(reportId) {
    return axios
      .delete(`${endpoints.REPORTS}/${reportId}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }

  static cloneReport(params) {
    return axios
      .post(`${endpoints.REPORTS_CLONE}/${params.id}`, params)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error
      })
  }
}

export default ReportsApi



// WEBPACK FOOTER //
// ./src/api/ReportsApi.js